module.exports = __webpack_public_path__ + "img/add--filled 1.3f299c9c.svg";